import './node-buttons.css';

import { Button } from 'primereact/button';
import React, { MouseEvent } from 'react';

import { PositionedTree } from '../../../pages/mindmap/types';
import { useMindmap } from './../../../pages/mindmap/use-mindmap';
import { ToolPanelButton } from './tool-panel-button';

export const BUTTON_ICON_HEIGHT = 48;
export const BUTTON_ICON_WIDTH = 48;
export const BUTTON_PADDING = 8;

export const NodeButtons = ({ node }: { node: PositionedTree }) => {
  const isRootNode = node.pid == null;
  const topNodeButtonsCount = isRootNode ? 2 : 3;
  const minWidth = topNodeButtonsCount * BUTTON_ICON_WIDTH + (topNodeButtonsCount - 1) * BUTTON_PADDING;

  const onClick = (e: MouseEvent) => {
    // prevent registration as map or node click
    e.preventDefault();
    e.stopPropagation();
  };

  const {
    manipulation: { addChild, addSibling },
  } = useMindmap();

  const onAddTopSiblingClick = (e: MouseEvent) => {
    addSibling(false, node.id);
    onClick(e);
  };

  const onAddChildClick = (e: MouseEvent) => {
    addChild(node.id);
    onClick(e);
  };

  const onAddBottomSiblingClick = (e: MouseEvent) => {
    addSibling(false, node.id);
    onClick(e);
  };

  const buttonClasses = 'flex align-items-center justify-content-center p-button-rounded';

  return (
    <div>
      <div
        style={{
          position: 'absolute',
          left: node.x,
          top: node.y - BUTTON_ICON_HEIGHT - BUTTON_PADDING,
          width: node.width,
          minWidth: minWidth,
          margin: '0 auto',
          transform: node.width < minWidth ? `translateX(${(node.width - minWidth) / 2}px)` : undefined,
        }}
        className="flex justify-content-between flex-wrap p-0 node-buttons-container"
      >
        <div></div>
        {!isRootNode ? (
          <Button onClick={onAddTopSiblingClick} icon="pi pi-plus" className={`${buttonClasses} p-button-primary`} />
        ) : (
          <div></div>
        )}
        <div className={buttonClasses}>
          <ToolPanelButton onClick={onClick} node={node} />
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          left: node.x,
          top: node.y + node.height + BUTTON_PADDING,
          width: node.width,
        }}
        className="flex justify-content-center flex-wrap p-0 node-buttons-container"
      >
        <Button onClick={onAddChildClick} icon="pi pi-plus" className={`${buttonClasses} p-button-primary`} />
      </div>
      <div
        style={{
          position: 'absolute',
          left: node.x + node.width + BUTTON_PADDING,
          top: node.y + node.height / 2 - BUTTON_ICON_WIDTH / 2,
        }}
        className="flex justify-content-center flex-wrap p-0 node-buttons-container"
      >
        {!isRootNode && (
          <Button onClick={onAddBottomSiblingClick} icon="pi pi-plus" className={`${buttonClasses} p-button-primary`} />
        )}
      </div>
    </div>
  );
};
